import api from './api';
import CitiesBrazil from './CitiesBrazil.json';

export const getStreetView = async (search: string) => {
  return await api.get(`/locations/streetview?location=${search}`);
};

export const getImageStreetView = async (filename: string) => {
  return await api.get(`/locations/streetview/${filename}`, {
    responseType: 'blob',
  });
};

export const getDetailsAddress = async (search: string) => {
  return await api.get(`/locations/details/address?address=${search}`);
};

export const getRoutes = async (origin: string, destination: string) => {
  return await api.get(
    `/locations/details/betweentwocoordinates?origin=${origin}&destination=${destination}`
  );
};

export const getNearby = async (location: string, type: string) => {
  return await api.post(`/locations/nearby/`, { location, type });
};

export const getCitiesBrazil = () => {
  return CitiesBrazil;
};
